import { fromJS, merge } from "immutable";
import { FluxStandardAction } from '__utils/type';
import * as Actions from 'constants/actions'

export interface userPaymentDetailState {
    userPaymentDetailView: Array<any>;
    totalValidOrdersAmount: number;
    loopBackURL?: string;
}

const rawState: userPaymentDetailState = {
    userPaymentDetailView: [],
    totalValidOrdersAmount: 0
}
const intialState = fromJS(rawState);

export default function paymentFlowReducer(
    state = intialState,
    action: FluxStandardAction
)
{
    switch (action.type)
    {
        case Actions.UPDATE_USER_PAYMENT_DETAIL_VIEW:
            return merge(state, fromJS({ userPaymentDetailView: action.payload }));
        case Actions.UPDATE_TOTAL_VALID_ORDERS_AMOUNT:
            return merge(state, fromJS({ totalValidOrdersAmount: action.payload }));
        case Actions.UPDATE_LOOP_BACK_URL:
            return merge(state, fromJS({ loopBackURL: action.payload }));
        default:
            return state;
    }
}
    